
// const CLIENT_DATA = [
//     {
//         name:"Client 1", 
//         ASSET_CODE: "E_LOGIN_CLIENT_1_IMAGE"
//     },
//     {
//         name:"Client 2", 
//         ASSET_CODE: "E_LOGIN_CLIENT_2_IMAGE"
//     },
//     {
//         name:"Client 3", 
//         ASSET_CODE: "E_LOGIN_CLIENT_3_IMAGE"
//     },
//     {
//         name:"Client 4", 
//         ASSET_CODE: "E_LOGIN_CLIENT_4_IMAGE"
//     },
//     {
//         name:"Client 5", 
//         ASSET_CODE: "E_LOGIN_CLIENT_5_IMAGE"
//     },
//     {
//         name:"Client 6", 
//         ASSET_CODE: "E_LOGIN_CLIENT_6_IMAGE"
//     },
//     {
//         name:"Client 7", 
//         ASSET_CODE: "E_LOGIN_CLIENT_7_IMAGE"
//     },
//     {
//         name:"Client 8", 
//         ASSET_CODE: "E_LOGIN_CLIENT_8_IMAGE"
//     },
//     {
//         name:"Client 9", 
//         ASSET_CODE: "E_LOGIN_CLIENT_9_IMAGE"
//     },
//     {
//         name:"Client 10", 
//         ASSET_CODE: "E_LOGIN_CLIENT_10_IMAGE"
//     },
//     {
//         name:"Client 11", 
//         ASSET_CODE: "E_LOGIN_CLIENT_11_IMAGE"
//     },
//     {
//         name:"Client 12", 
//         ASSET_CODE: "E_LOGIN_CLIENT_12_IMAGE"
//     },
//     {
//         name:"Client 13", 
//         ASSET_CODE: "E_LOGIN_CLIENT_13_IMAGE"
//     },
//     {
//         name:"Client 14", 
//         ASSET_CODE: "E_LOGIN_CLIENT_14_IMAGE"
//     },
//     {
//         name:"Client 15", 
//         ASSET_CODE: "E_LOGIN_CLIENT_15_IMAGE"
//     },
//     {
//         name:"Client 16", 
//         ASSET_CODE: "E_LOGIN_CLIENT_16_IMAGE"
//     },
//     {
//         name:"Client 17", 
//         ASSET_CODE: "E_LOGIN_CLIENT_17_IMAGE"
//     },
//     {
//         name:"Client 18", 
//         ASSET_CODE: "E_LOGIN_CLIENT_18_IMAGE"
//     }
// ];
const NEWS_DATA = [
    {
        name: "News 1", 
        ASSET_CODE: "E_LOGIN_NEWS_1_IMAGE",
        CONTENT_CODE: "E_LANDING_PAGE_NEWS_1"
    },
    {
        name: "News 2", 
        ASSET_CODE: "E_LOGIN_NEWS_2_IMAGE",
        CONTENT_CODE: "E_LANDING_PAGE_NEWS_2"
    }
];

export const contentData = {
    // CLIENT_DATA,
    NEWS_DATA
}
